export default __webpack_public_path__ + "static/media/financial-advisor-man-1.5x.06d26cad.png";